import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const unitList = createAsyncThunk('unit/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `unit`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'level_id': data?.level_id,
                'premise_id': data?.premise_id,
                'type': data?.type,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const unitAdmin = createAsyncThunk('unit/admin', async ({ premise_id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'unit_admin',
            params: {
                premise_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const unitDetails = createAsyncThunk('unit/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `unit/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addUnit = createAsyncThunk('unit/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'unit',
            data: {
                "premise_id": data?.values?.premise,
                "zone_id": data?.values?.zone,
                "level_id": data?.values?.level,
                "unit_number": data?.values?.unit_no,
                "size": parseFloat(data?.values?.area),
                "bedroom": parseInt(data?.values?.bedroom),
                "hall": parseInt(data?.values?.hall),
                "kitchen": parseInt(data?.values?.kitchen),
                "penthouse": data?.values?.penthouse,
                "open_terrace_area": parseFloat(data?.values?.open_terrace_area),
                "closed_terrace_area": parseFloat(data?.values?.closed_terrace_area),
                "fully_enclosed_terrace": parseFloat(data?.values?.fully_enclosed_terrace),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateUnit = createAsyncThunk('unit/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'unit',
            data: {
                "premise_id": data?.values?.premise,
                "zone_id": data?.values?.zone,
                "level_id": data?.values?.level,
                "unit_id": data?.values?.id,
                "unit_number": data?.values?.unit_no,
                "size": parseFloat(data?.values?.area),
                "bedroom": parseInt(data?.values?.bedroom),
                "hall": parseInt(data?.values?.hall),
                "kitchen": parseInt(data?.values?.kitchen),
                "penthouse": data?.values?.penthouse,
                "open_terrace_area": parseFloat(data?.values?.open_terrace_area),
                "closed_terrace_area": parseFloat(data?.values?.closed_terrace_area),
                "fully_enclosed_terrace": parseFloat(data?.values?.fully_enclosed_terrace),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateOccupancyStatus = createAsyncThunk('unit/updateOccupancyStatus', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'unit_occupancy_status',
            data: {
                unit_id: data?.values?.unit_id,
                occupancy_status: data?.values?.occupancy_status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delUnit = createAsyncThunk('unit/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `unit/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const unit = createSlice({
    name: 'unit',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    reducers: {
        removeUnit: (state, action) => {
            state.list = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(unitList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(unitList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(unitList.rejected, (state, action) => {
            state.loading = false;
        })

        builder.addCase(unitDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export const { removeUnit } = unit.actions;
export default unit.reducer;